// extracted by mini-css-extract-plugin
export var infoRow = "_ok-2";
export var labelContainer = "_ok-0";
export var rightInfo = "_ok-1";